/** Public website API paths (relative to API base URL). */
export const publicWebRoutes = Object.freeze({
  companies: '/api/VCCIPL_WEB/companies',
  rightsCompanies: '/api/VCCIPL_WEB/rights-companies',
  firstCallCompanies: '/api/VCCIPL_WEB/first-call-companies',
  bookClosures: '/api/VCCIPL_WEB/book-closures',
  bookClosureCompanies: '/api/VCCIPL_WEB/book-closure-companies',
  rightsInfo: (isin: string, excludeHtml = false) =>
    `/api/VCCIPL_WEB/rights-info?isin=${encodeURIComponent(isin)}&excludeHtml=${excludeHtml}`,
  openExitCompanies: '/api/VCCIPL_WEB/open-exit-companies',
  openExitInfo: (isin: string) => `/api/VCCIPL_WEB/open-exit-info?isin=${encodeURIComponent(isin)}`,
  contactUpdate: '/api/VCCIPL_WEB/contact-update',
  openExitOffer: '/api/VCCIPL_WEB/open-exit-offer',
  contactMessage: '/api/VCCIPL_WEB/contact-message',
  rightsQuery: '/api/VCCIPL_WEB/rights-query',
  issueDownload: (type: number) => `/api/VCCIPL_WEB/issue-download?type=${type}`,
  sebiReportCounts: '/api/VCCIPL_WEB/sebi/report-counts',
  sebiFinancialYearReport: '/api/VCCIPL_WEB/sebi/financial-year-report',
  investorSendOtp: '/api/VCCIPL_WEB/investor-login/otp',
  investorVerifyOtp: '/api/VCCIPL_WEB/investor-login/otp/verify',
  investorVerify: '/api/VCCIPL_WEB/investor-verify',
  investorLogout: '/api/VCCIPL_WEB/investor-verify/logout',
})
